export const EXPECTED_LAUNCH_DATE = "Earliest date by which at least one of the nodes will be launched";
export const DAILY_SHIPMENT_PER_NODE = "Average shipment volume that any node in this plan can expect over a day";
export const WAREHOUSE_DETAILS = "Operational Nodes under this Launch Plan";
export const HOURS_IN_SEVEN_DAYS = 168;
export const LOWER_LIMIT_FOR_NUMBER_OF_NODES_PLANNED = 0;
export const UPPER_LIMIT_FOR_NUMBER_OF_NODES_PLANNED = 5000;
export const LOWER_LIMIT_FOR_DAILY_SHIPMENT_PER_NODE = 0;
export const UPPER_LIMIT_FOR_DAILY_SHIPMENT_PER_NODE = 100000;